import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ManageUsersService } from './manage-users.service';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog'
import { TokenStorageService } from '../services/auth-user-service/token-storage.service';

import { AuthUserService } from '../services/auth-user-service/auth-user.service';

import { IUserData } from './manage-users.interface';

import { MatSidenav } from '@angular/material/sidenav';

import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mcrit-gestio-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.scss']
})
export class ManageUsersComponent implements OnInit {
  @ViewChild('password1') password1Input;
  @ViewChild('password2') password2Input;

  public userList: Array<IUserData> = [];
  public userInfo: any = {};
  public editUserData: IUserData;
  public showDialog: boolean = false;
  public showAsyncProgress: boolean = false;
  public dlgDialog: any;
  private unsubscriber : Subject<void> = new Subject<void>();

  private resetUserModel(): void {
      this.editUserData = {
        email: '',
        name: '',
        password: '',
        admin: false,
        active: true,
        id: 'NEW',
        telefon: '',
        anys_experiencia: 0,
        data_inici: (new Date()).toISOString().slice(0, 10),
        data_fi: null,
        formacio: '',
        carrec: '',
        rol: null
    };
  }

  private reduce(payload: any, state): any {
    switch (payload.action) {
      case 'ADD_USER':
       return [payload.newState, ... state];
      case 'DELETE_USER':
      return state.filter((item: IUserData) => item.email !== payload.newState.email);
      case 'UPDATE_USER_ACL':
      case 'UPDATE_USER':
        return state.map((item: IUserData) => {
          if (item.email === payload.newState.email) {
            return Object.assign({}, payload.newState);
          }
          return item;
        });
      default:
      return state;
    }
  }

  private asyncCRUD({action, newState}): void {
    this.showAsyncProgress = true;
    let asyncAction;
    switch (action) {
      case 'ADD_USER':
        asyncAction = this.manageUsersService.create(newState);
        break;
      case 'UPDATE_USER_ACL':
        asyncAction = this.manageUsersService.setACL(newState);
        break;
      case 'UPDATE_USER':
        asyncAction = this.manageUsersService.update(newState);
        break;
      case 'DELETE_USER':
        asyncAction = this.manageUsersService.destroy(newState);
        break;
      default:
        this.showAsyncProgress = false;
        return;
    }
    asyncAction.subscribe(
      asyncData => this.userList = this.reduce({
        newState: asyncData,
        action: action
      }, this.userList),
      err => console.log(err),
      () => this.showAsyncProgress = false
    );
  }

  public addNewUser(): void {
    this.resetUserModel();
    this.showDialog = true;
  }

  public addOrUpdateUser(e: Event): void {
    e.preventDefault();
    this.showDialog = false;
    const payload = {
      action: (this.editUserData.id === 'NEW' ? 'ADD_USER' : 'UPDATE_USER'),
      newState: this.editUserData
    };
    this.userList = this.reduce(payload, this.userList);
    this.asyncCRUD(payload);
  }

  public editUser(user: IUserData): void {
    this.editUserData = Object.assign({}, user);
    this.showDialog = true;
  }

  public changeActivity(type, user, newValue) {
    const changedKey = {};
    changedKey[type] = newValue;

    const payload = {
      action: 'UPDATE_USER_ACL',
      newState: Object.assign({}, user, changedKey)
    };
    this.userList = this.reduce(payload, this.userList);
    this.asyncCRUD(payload);
  }

  public deleteUser(user) {
    if(confirm("Confirma l'esborratde l'usuari")){
      const payload = {
        action: 'DELETE_USER',
        newState: Object.assign({}, user)
      };
      this.userList = this.reduce(payload, this.userList);
      this.asyncCRUD(payload);
   }
  }

  public validateEqualPassword($event: Event): void {
    const passwordElement = this.renderer.selectRootElement('input[type=password]');
    if (this.password1Input.value === this.password2Input.value) {
      //this.renderer.invokeElementMethod(passwordElement, 'setCustomValidity', ['']);
    } else {
      //this.renderer.invokeElementMethod(passwordElement, 'setCustomValidity', ['Les claus no coincideixen']);
    }
  }

  constructor(private authUserService: AuthUserService, private dialog: MatDialog, protected router: Router, private tokenStorage: TokenStorageService, private manageUsersService: ManageUsersService, private renderer: Renderer2) {
    //const jwtHelper = new JwtHelper();
    const token = localStorage.getItem('token');

    //this.userInfo = jwtHelper.decodeToken(token);//ALERTA!!!
    this.userInfo = this.tokenStorage.getUser();
    //console.log(this.userInfo);
    this.resetUserModel();
  }

  ngOnInit() {
   this.manageUsersService.getList()
      .subscribe(userList => {
        this.userList = userList
   });
  
   history.pushState(null,  document.title, location.href);

    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
    });

  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
